import { MAILS, THREADS } from './fixtures';
import type { BoxFolder, BoxKey, BoxMail, BoxThreadMsg } from './types';

/** Thư của một hộp (và thư mục; bỏ trống = Hộp thư đến). */
export function mailsOf(box: BoxKey | 'all', folder?: BoxFolder, mails: readonly BoxMail[] = MAILS): BoxMail[] {
  return mails.filter((m) => (box === 'all' || m.box === box) && m.folder === folder);
}

export function unreadCount(mails: readonly BoxMail[]): number {
  return mails.reduce((n, m) => n + (m.unread ? 1 : 0), 0);
}

/** Thư chưa xử lý: chưa đánh dấu xong, không phải thư đi. */
export function openCount(mails: readonly BoxMail[]): number {
  return mails.filter((m) => !m.done && !m.out).length;
}

export function threadOf(id: number): readonly BoxThreadMsg[] {
  return THREADS[id] ?? [];
}
